import { getAreaNext } from "@/views/commonApi";
let dictObj = {
  // 订单来源
  orderSource: new Map([
    [1, "平台订单"],
    [2, "三方订单"]
  ]),
  // 服务商充值方式
  rechargeMethod: new Map([
    [1, "预充值"],
    [2, "后付款"]
  ]),
  // 服务商钱包状态
  walletStatus: new Map([
    [0, "欠款"],
    [1, "正常"]
  ]),
  // 是否
  whetherOrNot: new Map([
    [1, "是"],
    [0, "否"]
  ]),
  // 是否
  merchantStatus: new Map([
    [1, "草稿"],
    [2, "启用"],
    [3, "已关闭"]
  ]),
  // 回单方式
  receiptWay: new Map([
    [0, "待确认"],
    [1, "线下带回"],
    [2, "快递"]
  ]),
  // 岗位标签
  jobLabel: new Map([
    [1, "领导"],
    [2, "调度"],
    [3, "车队长"],
    [4, "客服"],
    [5, "普通员工"]
  ]),
  //  公司类型
  companyType: new Map([
    [1, "总公司"],
    [10, "分公司"],
    [20, "子公司"],
    [30, "渠道商"]
  ]),
  //  公司类型
  companyType2: new Map([
    [10, "分公司"],
    [20, "子公司"],
    [30, "渠道商"]
  ]),
  //  在跑状态
  runStatus: new Map([
    [0, "停跑"],
    [1, "在跑"]
  ]),
  //  在跑状态
  auditStatus: new Map([
    [-1, "已驳回"],
    [0, "待审批"],
    [1, "审核通过"],
    [2, "已撤销"]
  ]),
  //  司机上报状态
  reportStatus: new Map([
    [0, "未上报"],
    [1, "接单中"],
    [2, "配满发车"],
    [3, "休息中"]
  ]),
  //  排班状态
  schedulingStatus: new Map([
    [0, "待排班"],
    [1, "出勤"],
    [2, "不出勤"]
  ]),
  //  回单要求
  receiptType: new Map([
    [0, "无需回单"],
    [1, "纸质回单"],
    [2, "电子回单"]
  ]),
  //  当天存在下单记录
  orderRecord: new Map([
    [0, "不存在"],
    [1, "存在"]
  ]),
  //  处理状态
  processingStatus: new Map([
    [0, "未处理"],
    [1, "已处理"]
  ]),
  //  投诉建议问题类型
  questionType: new Map([
    [0, "服务态度"],
    [1, "运送时效"],
    [2, "平台建议"],
    [3, "调度问题"],
    [4, "费用问题"],
    [5, "其他"]
  ]),
  //  处理状态
  handleType: new Map([
    [0, "待处理"],
    [1, "已处理"]
  ]),
  //  下单方式
  orderFrom: new Map([
    [1, "小程序下单"],
    [2, "客服代下单"],
    [11, "助手推送"],
    // [12, "三方补仓录入"],
    [21, "第三方推送"],
  ]),
  //  订单状态
  orderStatus: new Map([
    [1, "待支付"],
    [10, "待派单"],
    [20, "运输中"],
    [30, "待回单"],
    [100, "已完成"],
    [0, "已取消"]
  ]),
  //  步骤编号
  stepType: new Map([
    [1, "货主下单"],
    [2, "客服代下单"],
    [3, "三方系统推送"],
    [4, "三方订单补仓"],
    [5, "货主支付"],
    [10, "调度派单"],
    [11, "订单改派"],
    [21, "装货点装货"],
    [22, "卸货点卸货"],
    [25, "回单订单跟单"],
    [31, "订单取消"],
    [41, "订单退款"]
  ]),
  //  步骤状态
  stepStatus: new Map([
    [0, "未完成"],
    [1, "已完成"]
  ]),
  //  订单取消类型
  cancelType: new Map([
    [11, "货主取消"],
    [21, "司机取消"]
  ]),
  //  审批状态（上线费用）
  onLineAuditStatus: new Map([
    [-1, "未通过"],
    [0, "待审核"],
    [1, "已通过"]
  ]),
  //  司机审批状态
  driverAuditStatus: new Map([
    [-1, "未通过"],
    [0, "待审核"],
    [1, "审核通过"],
    [2, "已撤回"]
  ]),
  //  欠款处理转台
  debtStatus: new Map([
    [-1, "已作废"],
    [0, "待还款"],
    [1, "已还款"]
  ]),
  //  提现处理转台
  withdrawStatus: new Map([
    [-1, "失败"],
    [0, "待处理"],
    [1, "提现成功"]
  ]),
  //  还款方式
  paymentType: new Map([
    [1, "财务还款"],
    [10, "微信支付"],
    [20, "钱包支付"]
  ]),
  //  货主来源
  promotionType: new Map([
    [0, "小程序注册"],
    [1, "公司推广"],
    [2, "司机推广"]
  ]),
  //  欠款类型
  debtType: new Map([
    [1, "平台预付订单服务费及定金"],
    [2, "平台垫资充值"],
    [3, "车辆上线费用欠缴"]
  ]),
  //  钱包交易类型
  recordType: new Map([
    // [1, "平台提现"],
    // [2, "平台提现失败，返还钱包"],
    // [10, "钱包充值"],
    // [11, "钱包充值"],
    // [20, "平台充值"],
    // [31, "平台服务费(含可退订金)"],
    // [32, "返还平台服务费(含订金)"],
    // [33, "返还订金"],
    // [40, "平台推广返佣"],
    // [50, "运费结算"],
    // [51, "订单支付"],
    // [52, "订单退款"],
    [11, "平台充值"],
    [51, "订单支付"],
    [52, "订单退款"]
  ]),
  //  线路类型
  lineType: new Map([[1, "热门网格线路"]])
};

/**
 * @description 遍历转换option
 */
const initDict = function () {
  for (const m in dictObj) {
    dictObj[`${m}Options`] = trans2Options(dictObj?.[m]);
  }
  return dictObj;
};

/**
 * @description map转option
 */
const trans2Options = function (objMap) {
  const resArr = [];
  for (const ele of objMap) {
    resArr.push({
      dictCode: ele?.[0],
      dictLabel: ele?.[1]
    });
  }
  return resArr;
};
const getLocalLabel = function (name, code) {
  return dictObj[name].get(code) || code;
};

/**
 * @description 遍历转换option
 */
const initDict2 = function (val) {
  let obj = JSON.parse(localStorage.getItem("dict"));
  let arr = [];
  for (const m in obj) {
    if (val === m) {
      arr = [...obj[`${m}`]];
    }
  }
  return arr;
};
/**
 * @description 遍历转换option
 */
const getConfig = function (val) {
  let obj = JSON.parse(localStorage.getItem("config"));
  let arr = [];
  let label = "";
  for (const m in obj) {
    if (val === m) {
      arr = [...obj[`${m}`]];
    }
  }
  return arr;
};
/**
 * @description 遍历转换option
 */
const getLabel = function (val, key) {
  let obj = JSON.parse(localStorage.getItem("dict"));
  let arr = [];
  let label = "";
  for (const m in obj) {
    if (val === m) {
      arr = [...obj[`${m}`]];
    }
  }
  if (arr && arr.length > 0) {
    arr.forEach((item) => {
      if (item.dictCode == key) {
        label = item.dictLabel;
      }
    });
  }
  if (!label) {
    return key;
  } else {
    return label;
  }
};
const getArea = async function (data) {
  let arr = [];
  try {
    const res = await getAreaNext(data);
    if (res.code === 200) {
      arr = res.data;
    }
  } catch (error) {
    // 处理错误，例如记录日志或抛出错误
    console.error("Error fetching area:", error);
  }
  return arr;
};
const transformCity = async function (province, city, area) {
  let provinceName = "";
  let cityName = "";
  let districtName = "";
  try {
    // 获取省份名称
    const provinceRes = await getAreaNext();
    if (provinceRes.code !== 200) {
      throw new Error("获取省份名称失败");
    }
    provinceRes.data.forEach((item) => {
      if (item.areaCode === province) {
        provinceName = item.areaExtName;
      }
    });

    // 获取市名称
    const cityRes = await getAreaNext({ code: province });
    if (cityRes.code !== 200) {
      throw new Error("获取市名称失败");
    }
    cityRes.data.forEach((item) => {
      if (item.areaCode === city) {
        cityName = item.areaExtName;
      }
    });

    // 获取区名称
    const districtRes = await getAreaNext({ code: city });
    if (districtRes.code !== 200) {
      throw new Error("获取区名称失败");
    }
    districtRes.data.forEach((item) => {
      if (item.areaCode === area) {
        districtName = item.areaExtName;
      }
    });

    // 返回完整的省市区名称
    return `${provinceName}-${cityName}-${districtName}`;
  } catch (error) {
    // 处理错误，例如显示错误消息或进行其他操作
    console.error("获取省市区名称时出错:", error);
    // 可以选择抛出一个新的错误，或者返回一个默认值/错误信息
    return "获取省市区名称失败";
  }
};
export { initDict, initDict2, getLabel, transformCity, getConfig, getLocalLabel };
